import classNames from 'classnames';
import type { ReactElement } from 'react';
import type { CookieListProps } from './CookieList.data';
import styles from './CookieList.module.scss';

export default function CookieList(_props: CookieListProps): ReactElement {
  return (
    <div className={classNames(styles.cookieList)}>
      {/* <!-- OneTrust Cookies List start --> */}
      <div id="ot-sdk-cookie-policy"></div>
      {/* <!-- OneTrust Cookies List start --> */}
    </div>
  );
}
